import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';
@Component({
  standalone: false,
  selector: 'generic-drag-select.component',
  templateUrl: 'generic-drag-select.component.html',
  styleUrl: 'generic-drag-select.component.css'
})
export class GenericDragSelectComponent {

  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public model: any) {

    this.current = model.current as any[];
    this.available = model.available as any[];
    this.available.sort(this.compare);
    this.onSave = model.onSave as Function;
    this.sortOrder = model.sortOrder ?? [];
    this.enableSorting = model.enableSorting ?? false; 

  }
  public current: any[] = [];
  public available: any[] = [];
  public onSave?: Function;
  public sortOrder: { fieldName: string; ascending: boolean }[] = [];
  public enableSorting: boolean = false;


  toggleSortDirection(fieldName: string | undefined): void {
    if (!this.enableSorting || !fieldName) return;
    const sortItem = this.sortOrder.find(s => s.fieldName === fieldName);
    if (sortItem) {
      sortItem.ascending = !sortItem.ascending;
    }
  }

  toggleSortField(fieldName: string | undefined): void {
    if (!this.enableSorting || !fieldName) return;
    const index = this.sortOrder.findIndex(s => s.fieldName === fieldName);
    if (index >= 0) {
      this.sortOrder.splice(index, 1);
    } else {
      this.sortOrder.push({ fieldName, ascending: true });
    }
  }


  isInSortOrder(fieldName: string | undefined): boolean {
    return this.enableSorting && !!fieldName && this.sortOrder.some(s => s.fieldName === fieldName);
  }

  getSortDirection(fieldName: string | undefined): boolean {
    if (!this.enableSorting || !fieldName) return true;
    return this.sortOrder.find(s => s.fieldName === fieldName)?.ascending ?? true;
  }

  getSortPriority(fieldName: string | undefined): number {
    if (!this.enableSorting || !fieldName) return -1;
    return this.sortOrder.findIndex(s => s.fieldName === fieldName);
  }

  getRequestParams(): string {
    var result = "";
    Object.keys(this.model.requestParams).forEach((key: string) => {
      if (result.length == 0) result += "?";
      else result += "&";
      var value = this.model.requestParams[key] as string;
      result += `${key}=${value}`;
    })
    return result;
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    this.available.sort(this.compare);
    if (this.enableSorting) {
      const validFieldNames = this.current
        .map(c => c.fieldProfile?.fieldName)
        .filter((f): f is string => !!f);
      this.sortOrder = this.sortOrder.filter(s => validFieldNames.includes(s.fieldName));
    }

    const func = this.model.onChange as Function;
    if (func) func();
  }


  moveAllLeft() {
    var len = this.available.length;
    for (var i = 0; i < len; i++) {
      transferArrayItem(this.available, this.current, 0, this.current.length);
    }
  }

  moveAllRight() {
    var len = this.current.length;
    for (var i = 0; i < len; i++) {
      transferArrayItem(this.current, this.available,0 , this.available.length);
    }
    this.available.sort(this.compare);
  }

  saveChanges() {
    if (this.onSave) {
      this.onSave(this.current, this.available, this.sortOrder);
    }
    this.dialogRef.close();
  }

  compare(a:any, b:any) {
    if (a.caption < b.caption) {
      return -1;
    }
    if (a.caption > b.caption) {
      return 1;
    }
    return 0;
  }
}
